
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.93 1L3.81 6.718a.609.609 0 00.043.504.5.5 0 00.169.175.426.426 0 00.22.065h2.63L4.987 15l8.095-8.766a.563.563 0 00.133-.274.611.611 0 00-.022-.312.533.533 0 00-.17-.245.432.432 0 00-.262-.095H9.228L11.112 1H5.93z","fill":"url(#paint0_linear_1198_24081)","stroke":"#748190","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_1198_24081","x1":"8.287","y1":"10.825","x2":"7.866","y2":"-10.665","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".214","stop-color":"#748190"}}),_c('stop',{attrs:{"offset":".214","stop-color":"#141F31","stop-opacity":"0"}})])])])
          )
        }
      }
    